import React, { useState, useEffect } from 'react';
import GridFilterField from '../GridFilterField/GridFilterField';

const GridFilter = (props) => {

    const [data, setData] = useState([]);
    const [value, setValue] = useState([]);

    useEffect(() => {
        let tData = [];
        if (props?.data?.length > 0) {
            tData = props.data;
        }
        setData(tData);
    }, [props.data]);

    const onChanged = (p_value, p_key) => {
        let tValue = [...value];
        tValue = tValue?.filter(r => r.fieldname != p_key);
        tValue = tValue?.concat(p_value);
        setValue(tValue);
        if (props.onGridFilterChange) {
            props.onGridFilterChange(tValue);
        }
    }

    return (
        <div style={{ display: 'flex' }}>
            {data?.map(r => {
                return (
                    <div style={{ marginRight: 16 }}>
                        <GridFilterField keyfield={r.key} namefield={r.text} data={r.data} onChanged={onChanged} parentkey={r.parentid} parentvalue={value} combo={r.combo} />      
                    </div>
                );
            })}
        </div>
    );
}

export default GridFilter;